import mobileTextInput from './inputs/MobileTextInputControlView';
import mobileTextAreaInput from './inputs/MobileTextAreaInputControlView';
import mobileNumericInputControlView from  './inputs/MobileNumericInputControlView';
import mobileDateInputControlView from  './inputs/MobileDateInputControlView';
import mobileTimeInputControlView from  './inputs/MobileTimeInputControlView';
import mobileCheckboxControlView from  './inputs/MobileCheckboxControlView';
import mobileRadioButtonControlView from  './inputs/MobileRadioButtonControlView';
import mobileDropDownControlView from  './inputs/MobileDropDownControlView';
import mobileMaskedTextControlView from  './inputs/MobileMaskedTextControlView';
import mobileNumericStepperControlView from  './inputs/MobileNumericStepperControlView';
import mobilePasswordInputControlView from  './inputs/MobilePasswordInputControlView';
import mobileWebSignatureControlView from  './inputs/MobileWebSignatureControlView';
import mobileHorizontalSliderControlView from  './inputs/MobileHorizontalSliderControlView';
import mobileRankingControlView from  './inputs/MobileRankingControlView';
import mobileButtonControlView from './buttons/MobileButtonControlView';
import mobileSubmitButtonControlView from './buttons/MobileSubmitButtonControlView';
import mobilePageButtonControlView from './buttons/MobilePageButtonControlView';
import mobilePrintButtonControlView from './buttons/MobilePrintButtonControlView';
import mobilePlayFormButtonControlView from './buttons/MobilePlayFormButtonControlView';
import mobilePlayReportButtonControlView from './buttons/MobilePlayReportButtonControlView';
import mobileListService from "../../service/mobile/MobileListService";
import mobileTextControlView from './layouts/MobileTextControlView';
import mobileSmallTextControlView from './layouts/MobileSmallTextControlView';
import mobileLargeHeadingControlView from './layouts/MobileLargeHeadingControlView';
import mobileMediumHeadingControlView from './layouts/MobileMediumHeadingControlView';
import mobileSmallHeadingControlView from './layouts/MobileSmallHeadingControlView';
import mobileBulletTextControlView from './layouts/MobileBulletTextControlView';
import mobileLinkControlView from './layouts/MobileLinkControlView';
import mobileHorizontalSeparatorControlView from './layouts/MobileHorizontalSeparatorControlView';
import mobileListControlView from './containers/MobileListControlView';
import mobileProgressBarControlView from './containers/MobileProgressBarControlView';
import mobileCaptchaControlView from './containers/MobileCaptchaControlView';
import mobileFileAttachmentControlView from './containers/MobileFileAttachmentControlView';
import mobilePictureControlView from './containers/MobilePictureControlView';
import mobileTableControlView from './inputs/MobileTableControlView'
import mobileGroupControlView from './containers/MobileGroupControlView';

import mobileConstants from "../../mobile/commons/MobileFormsConstants";
import constants from 'Constants'

class MobileControlAfterRender {

    constructor(){ }

    controlList(){
        this._controlList = [
            // Inputs
            {
                factoryKey: mobileConstants.WEBSIGNATURE_FACTORY_KEY,
                control: mobileWebSignatureControlView,
                excludedAttributes: null
            },
            {
                factoryKey: mobileConstants.PASSWORD_INPUT_FACTORY_KEY,
                control: mobilePasswordInputControlView,
                excludedAttributes: ["align"]
            },
            {
                factoryKey: mobileConstants.NUMERIC_STEPPER_FACTORY_KEY,
                control: mobileNumericStepperControlView,
                excludedAttributes: null
            },
            {
                factoryKey: mobileConstants.MASK_TEXT_INPUT_FACTORY_KEY,
                control: mobileMaskedTextControlView,
                excludedAttributes: null
            },
            {
                factoryKey: mobileConstants.DROP_DOWN_FACTORY_KEY,
                control: mobileDropDownControlView,
                excludedAttributes: null
            },
            {
                factoryKey: mobileConstants.RADIO_BUTTON_FACTORY_KEY,
                control: mobileRadioButtonControlView,
                excludedAttributes: null
            },
            {
                factoryKey: mobileConstants.CHECKBOX_FACTORY_KEY,
                control: mobileCheckboxControlView,
                excludedAttributes: null
            },
            {
                factoryKey: mobileConstants.TIME_INPUT_FACTORY_KEY,
                control: mobileTimeInputControlView,
                excludedAttributes: null
            },
            {
                factoryKey: mobileConstants.DATE_INPUT_FACTORY_KEY,
                control: mobileDateInputControlView,
                excludedAttributes: null
            },
            {
                factoryKey: mobileConstants.NUMERIC_INPUT_FACTORY_KEY,
                control: mobileNumericInputControlView,
                excludedAttributes: null
            },
            {
                factoryKey: mobileConstants.MULTIPLE_TEXT_INPUT_FACTORY_KEY,
                control: mobileTextAreaInput,
                excludedAttributes: null
            },
            {
                factoryKey: mobileConstants.TEXT_INPUT_FACTORY_KEY,
                control: mobileTextInput,
                excludedAttributes: null
            },
            {
                factoryKey: mobileConstants.HORIZONTAL_SLIDER_FACTORY_KEY,
                control: mobileHorizontalSliderControlView,
                excludedAttributes: null
            },
            {
                factoryKey: mobileConstants.RANKING_FACTORY_KEY,
                control: mobileRankingControlView,
                excludedAttributes: null
            },

            // Buttons
            {
                factoryKey: mobileConstants.BUTTON_FACTORY_KEY,
                control: mobileButtonControlView
            },
            {
                factoryKey: mobileConstants.SUBMIT_BUTTON_FACTORY_KEY,
                control: mobileSubmitButtonControlView
            },
            {
                factoryKey: mobileConstants.PAGE_BUTTON_FACTORY_KEY,
                control: mobilePageButtonControlView
            },
            {
                factoryKey: mobileConstants.PRINT_BUTTON_FACTORY_KEY,
                control: mobilePrintButtonControlView
            },
            {
                factoryKey: mobileConstants.PLAY_FORM_BUTTON_FACTORY_KEY,
                control: mobilePlayFormButtonControlView
            },
            {
                factoryKey: mobileConstants.PLAY_REPORT_BUTTON_FACTORY_KEY,
                control: mobilePlayReportButtonControlView
            },

            // Layouts
            {
                factoryKey: mobileConstants.TEXT_FACTORY_KEY,
                control: mobileTextControlView
            },
            {
                factoryKey: mobileConstants.SMALL_TEXT_FACTORY_KEY,
                control: mobileSmallTextControlView
            },
            {
                factoryKey: mobileConstants.LARGE_HEADING_FACTORY_KEY,
                control: mobileLargeHeadingControlView
            },
            {
                factoryKey: mobileConstants.MEDIUM_HEADING_FACTORY_KEY,
                control: mobileMediumHeadingControlView
            },
            {
                factoryKey: mobileConstants.SMALL_HEADING_FACTORY_KEY,
                control: mobileSmallHeadingControlView
            },
            {
                factoryKey: mobileConstants.SMALL_HEADING_FACTORY_KEY,
                control: mobileSmallTextControlView
            },
            {
                factoryKey: mobileConstants.BULLET_TEXT_FACTORY_KEY,
                control: mobileBulletTextControlView
            },
            {
                factoryKey: mobileConstants.LINK_FACTORY_KEY,
                control: mobileLinkControlView
            },
            {
                factoryKey: mobileConstants.HORIZONTAL_SEPARATOR_FACTORY_KEY,
                control: mobileHorizontalSeparatorControlView
            },

            // Containers
            {
                factoryKey: mobileConstants.LIST_FACTORY_KEY,
                control: mobileListControlView
            },
            {
                factoryKey: mobileConstants.PROGRESS_BAR_FACTORY_KEY,
                control: mobileProgressBarControlView
            },
            {
                factoryKey: mobileConstants.CAPTCHA_FACTORY_KEY,
                control: mobileCaptchaControlView
            },
            {
                factoryKey: mobileConstants.FILE_ATTACHMENT_FACTORY_KEY,
                control: mobileFileAttachmentControlView
            },
            {
                factoryKey: mobileConstants.PICTURE_FACTORY_KEY,
                control: mobilePictureControlView
            },
            {
                factoryKey: mobileConstants.TABLE_FACTORY_KEY,
                control: mobileTableControlView
            },
            {
                factoryKey: mobileConstants.GROUP_FACTORY_KEY,
                control: mobileGroupControlView
            },
            {
                factoryKey: mobileConstants.CHECKBOX_GROUP_FACTORY_KEY,
                control: mobileGroupControlView
            },
            {
                factoryKey: mobileConstants.RADIO_BUTTON_GROUP_FACTORY_KEY,
                control: mobileGroupControlView
            }

        ];

        return this._controlList;
    }

    updateAttributes(controlInstance, mobileObject,  container){
        const element = $(constants.FORM_ID);
        controlInstance.id = mobileObject.id;
        controlInstance.$el = element;
        controlInstance.model.set("container", container, constants.MODEL_SILENT);
    }

    sendToRender(sectionId, mobileObject){
        let controlInstance = mobileListService.getMobileControl(mobileObject.id);
        if(controlInstance){
            const container = `sectionBodyContainer_${sectionId}`;
            this.updateAttributes(controlInstance, mobileObject, container);
            controlInstance.render({container: container});
        }
    }
}

const mobileControlAfterRender = new MobileControlAfterRender();
export default mobileControlAfterRender;